<template>
  <div class="ch-adult-btn">
    <ul>
      <li>
        <a href="#"
           @click.prevent="confirm"
           ref="confirm"
           class="round-btn-purple-f">확인</a>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  name: 'BottomButtons',
  props: {
    scopedValue: {
      type: Object
    }
  },
  methods: {
    confirm () {
      if (typeof this.scopedValue.confirmFn === 'function') {
        console.log('confirm action')
        this.scopedValue.confirmFn()
      }
    }
  }
}
</script>
